module.exports = __webpack_public_path__ + "img/Group 427320771@2x.3137e7e6.png";